if (!customElements.get('social-gallery-slider')) {
  customElements.define(
    'social-gallery-slider',
    class SocialGallerySlider extends HTMLElement {
      constructor() {
        super();

        this.flkty = null;
        this.onResizeCallback = () => this.onResize();
      }

      connectedCallback() {
        this.handleSliderState();
        this.listen();
      }

      onResize() {
        this.handleSliderState();

        if (this.flkty !== null) {
          this.flkty.resize();

          if (this.flkty.size.width >= this.flkty.slideableWidth) this.destroySlider();
        }
      }

      handleSliderState() {
        const slides = this.querySelectorAll('[data-slide]');
        const isInactive = this.classList.contains('carousel--inactive');

        if (isInactive && !window.theme.isMobile()) {
          this.destroySlider();
          return;
        }

        if (slides.length === 1 && window.theme.isMobile()) {
          this.destroySlider();
          return;
        }

        if (!this.flkty) {
          this.initSlider();
        }

        if (this.flkty.slideableWidth < this.flkty.size.width) this.destroySlider();
      }

      initSlider() {
        const hasTextCenter = this.classList.contains('text-center');

        this.classList.remove('carousel--inactive');

        this.flkty = new window.theme.Flickity(this, {
          cellSelector: '[data-slide]',
          prevNextButtons: true,
          pageDots: true,
          groupCells: true,
          cellAlign: hasTextCenter ? 'center' : 'left',
          contain: true,
          adaptiveHeight: false,
          draggable: true,
          on: {
            ready: () => {
              this.slidesTabIndex();
            },
            change: () => {
              this.slidesTabIndex();
            },
          },
        });

        this.createResizeClass();
      }

      createResizeClass() {
        if (typeof window.theme.Flickity.prototype._createResizeClass === 'function') return;

        window.theme.Flickity.prototype._createResizeClass = function () {
          this.element.classList.add('carousel--resize');
        };

        window.theme.Flickity.createMethods.push('_createResizeClass');

        const resize = window.theme.Flickity.prototype.resize;
        window.theme.Flickity.prototype.resize = function () {
          this.element.classList.remove('carousel--resize');
          resize.call(this);
          this.element.classList.add('carousel--resize');
        };
      }

      slidesTabIndex() {
        const slider = window.theme.Flickity.data(this);

        slider.cells.forEach((slide) => {
          let tabIndex = '-1';
          if (slide.element.classList.contains('is-selected')) {
            tabIndex = '0';
          }

          slide.element.querySelectorAll('a, button').forEach((link) => {
            link.setAttribute('tabindex', tabIndex);
          });
        });
      }

      destroySlider() {
        if (!this.classList.contains('flickity-enabled')) return;

        if (this.classList.contains('carousel')) {
          this.classList.add('carousel--inactive');
        }

        if (this.flkty !== null) {
          this.flkty.destroy();
          this.flkty = null;
        }
      }

      listen() {
        document.addEventListener('theme:resize:width', this.onResizeCallback);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:resize:width', this.onResizeCallback);
      }
    }
  );
}
